var _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52.3 52.3",
    style: {
      enableBackground: "new 0 0 52.3 52.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "ripley_com",
    viewBox: "-44.6 -64.4 89.3 128.9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6,30.8c0-0.6-0.8-0.8-0.8-0.8c-8-1.5-15.5-7.1-21.1-13C14.9,8.6,8.2-0.7,2.7-10.7C1.8-12.8,3.1-13,3.1-13 c15.6-6,18.2-21.6,18.2-25.8c0-19.7-18.7-25.6-35.5-25.6c-6.4,0-8.5,0.5-15.1,0.5c-7.7,0-12.3-0.5-13.5-0.5c-1,0-1.8,0.9-1.7,1.9 c0,0,0,0.1,0,0.1c0,4.8,10.9-3.3,10.9,12.6v63.5c0,14.7-10.3,10.6-10.3,14.2c0,1.2,1.3,1.6,2.1,1.6c3.8,0,8.2-0.5,14.4-0.5 c7.8,0,9.8,0.5,14.3,0.5c3.3,0,3.8-0.7,3.8-1.6c0-4.5-13.9,2.4-13.9-16.7v-66.9c0-4,2.9-4,7.2-4c15.2,0,27.3,8.5,27.6,24.5 c0.2,10.9-8,21.2-21.5,21.2c-1.6,0.1-3.2,0-4.8-0.3c-0.7,0-1.3,0.3-1.3,1.2c0,1.2,1,1.8,2.1,2.2c1.5,0.7,4.9,1.2,8.5,6.7 c9,14.8,19.2,37,42.4,37C45.5,32.6,44.6,31.6,44.6,30.8 M-43.2,60.4c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4 S-43.2,62.6-43.2,60.4z M-33.8,53.4c-0.1-6,4.6-10.9,10.6-11c0.1,0,0.3,0,0.4,0c3.9-0.1,7.5,2,9.4,5.3l-5.5,3.2 c-0.8-1.5-2.3-2.4-4-2.3c-2.7,0-4.8,2.2-4.8,4.8c0,2.7,2.2,4.8,4.8,4.8c1.7,0.1,3.2-0.8,4-2.3l5.5,3.1c-1.9,3.4-5.5,5.4-9.4,5.4 c-6,0.1-10.9-4.6-11-10.6C-33.8,53.7-33.8,53.5-33.8,53.4z M-12.3,53.4c0-6.1,4.9-11.1,11-11.1s11.1,4.9,11.1,11 c0,6.1-4.9,11.1-11,11.1c0,0,0,0-0.1,0c-6,0.1-11-4.8-11-10.8C-12.3,53.5-12.3,53.4-12.3,53.4z M3.6,53.4c-0.1-2.7-2.3-4.7-4.9-4.7 C-4,48.8-6.1,51-6,53.6c0.1,2.6,2.2,4.7,4.8,4.7c2.6,0.1,4.7-2,4.8-4.5C3.6,53.6,3.6,53.5,3.6,53.4L3.6,53.4z M44.6,51v12.8h-6.3 V51.6c0-2.1-1-3.4-3-3.4s-3.2,1.5-3.2,3.9v11.8h-6.2V51.6c0-2.1-1-3.4-3-3.4s-3.2,1.5-3.2,3.9v11.8h-6.3V42.9h6.3v1.9 c1-1.4,2.8-2.5,5.6-2.5c2.2-0.1,4.2,0.9,5.5,2.8c1.2-1.7,3.1-2.8,6-2.8C41.5,42.4,44.6,45.8,44.6,51z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ripley_com",
    width: 89.3,
    height: 128.9,
    x: -44.6,
    y: -64.4,
    transform: "matrix(0.3338 0 0 0.3338 26.1545 25.9684)",
    style: {
      overflow: "visible"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9164a76a097072a0851656387a931c3.svg";
export { ForwardRef as ReactComponent };